// import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
// import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ToastService } from '../../../../../services/toast.service';
// import { CommonService } from '../../../../../services/common/common.service';
// import { ExcelService } from '../../../../../services/export/excel.service';
// import { AuthService } from '../../../../../services/auth.service';
// import Swal from 'sweetalert2';
// import moment from 'moment';
// import { AttendanceService } from '../../../../../services/attendance-service/attendance.service';
// import { Router } from '@angular/router';
// import { EmployeeListService } from '../../../../../services/employee/employee-list.service';
// import { ValidationService } from '../../../../../services/validation/validation.service';
// import { lastValueFrom } from 'rxjs';
// import { CompanyService } from '../../../../../services/company/company.service';
// import { NgxMaterialTimepickerComponent } from 'ngx-material-timepicker';

// @Component({
//   selector: 'app-attendance-regularization',
//   templateUrl: './attendance-regularization.component.html',
//   styleUrl: './attendance-regularization.component.scss'
// })
// export class AttendanceRegularizationComponent {
//   dates: any = [];
//   form: any = '';
//   saveClick: boolean = false;
//   listData: any = [];
//   requestedListData: any = [];
//   regularaizationPage: boolean = true
//   isapprover: boolean = false;
//   date: any = 'dd-mm-yy'
//   angularDateFormat: any;
//   currency: any;
//   minDate: any;
//   maxDate: any;
//   employeeDetail: any;

//   hideCompany: boolean = false;
//   dateFormat: any = 'dd-MM-yyyy';
//   companyList: any = [];

//   @ViewChild('startTimePicker') startTimePicker!: NgxMaterialTimepickerComponent;
//   @ViewChild('endTimePicker') endTimePicker!: NgxMaterialTimepickerComponent;
//   @ViewChildren('startTimePicker') startTimePickers!: QueryList<NgxMaterialTimepickerComponent>;
//   @ViewChildren('endTimePicker') endTimePickers!: QueryList<NgxMaterialTimepickerComponent>;

//   constructor(
//     private readonly router: Router,
//     private readonly fb: FormBuilder,
//     private readonly toastService: ToastService,
//     private readonly commonService: CommonService,
//     private readonly companyService: CompanyService,
//     private readonly excelService: ExcelService,
//     private readonly auth: AuthService,
//     private readonly attendanceService: AttendanceService,
//     private readonly cdr: ChangeDetectorRef,
//     private readonly employeeService: EmployeeListService,
//     private readonly validation: ValidationService
//   ) {
//     this.form = this.fb.group({
//       company_id: [null, [Validators.required]],
//       employee_id: [null, [Validators.required]],
//       from_date: ['', [Validators.required]],
//       to_date: ['', [Validators.required]],
//       sections: this.fb.array([])
//     });

//   }

//   get sections(): FormArray {
//     return this.form.get('sections') as FormArray;
//   }

//   async ngOnInit() {
//     await this.setupUserPermissions();
//     await this.getCompanyList();
//     let data: any = this.commonService.getLocalStorageData();
//     //console.log(data);

//     await this.getEmployee(data?.userID);
//     this.getRegularizationDataToApprove();
//     this.getRequestedRegularizationData();
//     const currentRoute = this.router.url.split('/').pop();
//     this.maxDate = new Date();
//     this.minDate = new Date(this.employeeDetail.dateofjoin)


//     if (currentRoute == 'approve') {
//       this.regularaizationPage = false
//     } else if (currentRoute != 'request') {
//       const timePickerFormat = this.formatDate(currentRoute);
//       setTimeout(() => {
//         this.form.get('from_date').setValue(timePickerFormat.date);
//         this.form.get('to_date').setValue(timePickerFormat.date);
//         this.getRegularizationDataToRequest()
//       }, 100)
//     }
//   }

//   private async setupUserPermissions() {
//     const userData: any = this.commonService.getLocalStorageData();
//     if (userData) {
//       if (!userData.client) {
//         this.hideCompany = true;
//         this.form.patchValue({
//           company_id: userData.companyID
//         });
//         await this.getEmployeeList(userData.companyID);
//         if (userData.role == '4') {
//           this.form.patchValue({
//             employee_id: userData.userID
//           });
//           this.form.get('employee_id')?.disable();
//         }
//         this.getDateFormat(userData.companyID);
//       }
//     }
//   }

//   private async getDateFormat(companyId: any): Promise<void> {
//     try {
//       const resp = await lastValueFrom(this.companyService.getParametersById(companyId));
//       const dateFormat = resp?.data?.date_format;
//       if (dateFormat) {
//         this.dateFormat = resp?.data?.date_format.replace('mm', 'MM');
//         this.date = dateFormat;
//         this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(dateFormat);
//       }
//     } catch (err) {
//       console.error('Error fetching date format:', err);
//     }
//   }

//   getCompanyList(): void {
//     this.companyService.getClientCompanyList().subscribe({
//       next: (resp: any) => {
//         this.companyList = resp.data;
//       },
//       error: (err) => {
//         console.error('Error fetching company list:', err);
//       }
//     });
//   }


//   onCompanyChange(event: any): void {
//     const companyId = event.id;
//     if (companyId) {
//       this.getDateFormat(companyId);
//       this.getEmployeeList(companyId);
//     }
//     this.form.patchValue({
//       employee_id: null,
//     })
//   }

//   employeeList: any = [];
//   getEmployeeList(id: any) {
//     this.employeeService.getRequestEmployeeList({ company_id: id }).subscribe({
//       next: (resp: any) => {
//         this.employeeList = resp.data;
//       }
//     });
//   }

//   changePage() {
//     this.regularaizationPage = !this.regularaizationPage;
//   }
//   formSubmit() {
//     let rawData = this.form.getRawValue();
//     let formData = {
//       company_id: rawData.company_id,
//       employee_id: rawData.employee_id,
//       from_date: rawData.from_date,
//       to_date: rawData.to_date,
//       sections: this.form.value.sections.map((e: any) => ({
//         calendar_date: e.calendar_date,
//         checkin_time: moment(e.calendar_date)
//           .set({
//             hour: moment(e.checkin_time).hour(),
//             minute: moment(e.checkin_time).minute(),
//             second: moment(e.checkin_time).second(),
//             millisecond: 0
//           })
//           .format('YYYY-MM-DDTHH:mm:ss.SSS+00:00'),
//         checkout_time: moment(e.calendar_date)
//           .set({
//             hour: moment(e.checkout_time).hour(),
//             minute: moment(e.checkout_time).minute(),
//             second: moment(e.checkout_time).second(),
//             millisecond: 0
//           })
//           .format('YYYY-MM-DDTHH:mm:ss.SSS+00:00'),
//         comments: e.comments,
//       }))

//     }

//     this.saveClick = true;

//     if (this.form.valid) {
//       Swal.fire({
//         title: 'Are you sure want to save?',
//         showCancelButton: true,
//         confirmButtonColor: '#d33',
//         cancelButtonColor: '#3085d6',
//         confirmButtonText: 'Yes',
//         cancelButtonText: 'No',
//       }).then((result) => {
//         if (result.isConfirmed) {
//           this.attendanceService.punchRequest(formData).subscribe({
//             next: (resp) => {
//               this.toastService.success(`Success!`);
//               this.getRequestedRegularizationData()
//             },
//             error: (err) => {
//               this.toastService.failure(err.error.message);
//             },
//           });
//         }
//       });
//     } else {
//       this.updateFormErrors('form');
//     }
//   }

//   isInvalid(controlName: any): any {
//     const control = this.form.get(controlName);
//     return (
//       (this.saveClick && control?.invalid) ||
//       (this.saveClick && !!control?.errors) ||
//       (control?.invalid && (control.dirty || control.touched))
//     );
//   }

//   formErrors: any = {};
//   private updateFormErrors(type: any): void {
//     this.formErrors = {};

//     Object.keys(this.form.controls).forEach((field) => {
//       const control = this.form.get(field);
//       if (control && control.errors) {
//         this.formErrors[field] = control.errors;
//       }
//     });
//   }


//   formatDate(event: any) {
//     if (!event) {
//       return { date: null };
//     }
//     const date = new Date(event);
//     return {
//       date,
//     };
//   }

//   async loadCompanySettings(): Promise<void> {
//     return new Promise((resolve, reject) => {
//       const data: any = this.commonService.getLocalStorageData();

//       this.commonService.getCompanySettingFormat(data.companyID).subscribe({
//         next: (resp) => {
//           this.date = resp.data.date_format;
//           this.currency = resp.data.default_currency;
//           this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(this.date);
//           resolve();
//         },
//         error: (err) => {
//           reject(err);
//         }
//       });
//     });
//   }


//   async getEmployee(id: any): Promise<any> {
//     return new Promise((resolve, reject) => {
//       this.employeeService.getEmployeeView(id).subscribe({
//         next: (resp) => {
//           this.employeeDetail = resp.datas;
//           resolve(resp.data);
//         },
//         error: (err) => {
//           this.toastService.failure(err.message);
//           reject(err);
//         }
//       });
//     });
//   }


//   clearFormArray(formArray: FormArray) {
//     while (formArray.length !== 0) {
//       formArray.removeAt(0);
//     }
//   }

//   getRegularizationDataToRequest() {
//     let data = this.form.getRawValue();
//     let formData = {
//       employee_id: data.employee_id,
//       from_date: data.from_date,
//       to_date: data.to_date,
//     }

//     if (data.from_date && data.to_date) {
//       this.attendanceService.getRegularizationDataToRequest(formData).subscribe({
//         next: (resp: any) => {
//           const sectionsArray = this.form.get('sections') as FormArray;
//           this.clearFormArray(sectionsArray)

//           const startDate = moment(this.form.get('from_date')?.value).startOf('day');
//           const endDate = moment(this.form.get('to_date')?.value).startOf('day');

//           for (let currentDate = startDate; currentDate.isSameOrBefore(endDate); currentDate.add(1, 'day')) {
//             const formattedDate = currentDate.format('YYYY-MM-DD');

//             const existingSection = resp.data && resp.data.length > 0 ? resp.data.find((section: any) =>
//               moment(section.calendar_date).format('YYYY-MM-DD') === formattedDate
//             ) : '';

//             console.log("-=-=resp.data", resp.data);

//             if (existingSection) {
//               const shiftStartRaw = existingSection?.shift_config?.start_time || null;
//               const shiftEndRaw = existingSection?.shift_config?.end_time || null;

//               let shift_time = '---';
//               if (shiftStartRaw && shiftEndRaw) {
//                 const shiftStart = moment(shiftStartRaw, 'HH:mm:ss', true);
//                 const shiftEnd = moment(shiftEndRaw, 'HH:mm:ss', true);

//                 if (shiftStart.isValid() && shiftEnd.isValid()) {
//                   shift_time = `${shiftStart.format('hh:mm A')} - ${shiftEnd.format('hh:mm A')}`;
//                 }
//               }

//               // Handle check-in & check-out
//               const checkInMoment = moment.utc(existingSection?.attendance?.checkin_time);
//               const checkOutMoment = moment.utc(existingSection?.attendance?.checkout_time);

//               sectionsArray.push(this.fb.group({
//                 calendar_date: [existingSection.calendar_date || '', Validators.required],
//                 checkin_time: [
//                   checkInMoment.isValid() ? checkInMoment.format('HH:mm') : '',
//                   Validators.required
//                 ],
//                 checkout_time: [
//                   checkOutMoment.isValid() ? checkOutMoment.format('HH:mm') : '',
//                   Validators.required
//                 ],
//                 shift_time: [shift_time],
//                 status: [existingSection?.attendance?.attendance_status || '---'],
//                 comments: ['', [
//                   Validators.required,
//                   Validators.maxLength(255),
//                   Validators.pattern(this.validation.letterSingleSpace)
//                 ]]
//               }));
//             } else {
//               sectionsArray.push(this.fb.group({
//                 calendar_date: [formattedDate, Validators.required],
//                 checkin_time: ['', Validators.required],
//                 checkout_time: ['', Validators.required],
//                 shift_time: ['---'],
//                 status: ['---'],
//                 comments: ['', [Validators.required, Validators.maxLength(255), Validators.pattern(this.validation.letterSingleSpace)]]
//               }));
//             }
//           }
//         }
//       })
//     }

//   }

//   onDateChange(event: any, name: any) {
//     if (name == 'from_date') {
//       this.form.patchValue({
//         to_date: ""
//       })
//       const sectionsArray = this.form.get('sections') as FormArray;
//       this.clearFormArray(sectionsArray)
//     } else {
//       this.getRegularizationDataToRequest()
//     }
//   }



//   getRegularizationDataToApprove() {
//     this.attendanceService.getRegularizationDataToApprove().subscribe({
//       next: (resp: any) => {
//         this.listData = resp.data;
//         this.isapprover = resp.isapprover;
//       }
//     })
//   }

//   getRequestedRegularizationData() {
//     this.attendanceService.getRequestedRegularizationData().subscribe({
//       next: (resp: any) => {
//         this.requestedListData = resp.data;
//         //console.log("-====== resp.data=", resp.data);
//       }
//     })
//   }

//   onApprove(data: any) {
//     let formData = {
//       calendar_date: data.calendar_date,
//       checkin_time: data?.missedpunches?.checkin_time,
//       checkout_time: data?.missedpunches?.checkout_time,
//       employee_id: data.employee_id,
//       missedpunchrequest: "Approved"
//     }
//     Swal.fire({
//       title: 'Are you sure want to approve?',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       cancelButtonColor: '#3085d6',
//       confirmButtonText: 'Yes',
//       cancelButtonText: 'No',
//     }).then((result) => {
//       if (result.isConfirmed) {
//         this.attendanceService.updateAttendance(formData).subscribe({
//           next: (resp) => {
//             this.toastService.success(`Approved successfully`);
//             this.getRegularizationDataToApprove()
//           },
//           error: (err) => {
//             this.toastService.failure(err.error.message);
//           },
//         });
//       }
//     });
//   }
//   onReject(data: any) {
//     Swal.fire({
//       title: 'Are you sure want to reject?',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       cancelButtonColor: '#3085d6',
//       confirmButtonText: 'Yes',
//       cancelButtonText: 'No',
//     }).then((result) => {
//       if (result.isConfirmed) {
//         this.attendanceService.rejectRegularization({ _id: data._id, missedpunchrequest: "Rejected" }).subscribe({
//           next: (resp) => {
//             this.toastService.success(`Approved successfully`);
//             this.getRegularizationDataToApprove()
//           },
//           error: (err) => {
//             this.toastService.failure(err.error.message);
//           },
//         });
//       }
//     });
//   }

//   /**
//    * Open start time picker.
//    * If an index is provided, open the per-row picker at that index (when multiple pickers exist in the rows).
//    * Otherwise, fall back to the single ViewChild picker.
//    */
//   openStartTimePicker(index?: number): void {
//     try {
//       if (typeof index === 'number' && this.startTimePickers && this.startTimePickers.length > 0) {
//         const picker = this.startTimePickers.toArray()[index];
//         if (picker) {
//           picker.open();
//           return;
//         }
//       }

//       // fallback to single ViewChild if present
//       if (this.startTimePicker) {
//         this.startTimePicker.open();
//       }
//     } catch (err) {
//       console.error('Error opening start time picker:', err);
//     }
//   }

//   /**
//    * Open end time picker for a row.
//    * If index is provided, validate that the corresponding section has a checkin_time before opening the end picker.
//    * Otherwise, fallback to previous behavior which validated a top-level start_time.
//    */
//   openEndTimePicker(index?: number): void {
//     try {
//       const rawValue = this.form.getRawValue();

//       if (typeof index === 'number') {
//         const section = rawValue.sections && rawValue.sections[index];
//         const startTime = section ? section.checkin_time : null;
//         if (!startTime) {
//           this.toastService.failure('Please select start time first');
//           return;
//         }

//         if (this.endTimePickers && this.endTimePickers.length > 0) {
//           const picker = this.endTimePickers.toArray()[index];
//           if (picker) {
//             picker.open();
//             return;
//           }
//         }
//       }

//       // fallback to previous global behavior
//       const startTime = rawValue.start_time;
//       if (!startTime) {
//         this.toastService.failure('Please select start time first');
//         return;
//       }

//       if (this.endTimePicker) {
//         this.endTimePicker.open();
//       }
//     } catch (err) {
//       console.error('Error opening end time picker:', err);
//     }
//   }
// }

import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../../../services/common/common.service';
import { CompanyService } from '../../../../../services/company/company.service';
import { CalendarService } from '../../../../../services/calendar/calendar.service';
import { AuthService } from '../../../../../services/auth.service';
import { ToastService } from '../../../../../services/toast.service';
import { LeaveresumptionService } from '../../../../../services/leave-resumption/leaveresumption.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmployeeListService } from '../../../../../services/employee/employee-list.service';
import { AttendanceRegularizationService } from '../../../../../services/attendance-regularization/attendance-regularization.service';
import { MenuService } from '../../../../../services/menus/menu.service';

@Component({
  selector: 'app-attendance-regularization',
  templateUrl: './attendance-regularization.component.html',
  styleUrl: './attendance-regularization.component.scss'
})
export class AttendanceRegularizationComponent implements OnInit {
  // List data
  leaveList: any = [];
  viewType: 'grid' | 'list' = 'list';
  menuId: number = 0;
  myColumns: any = [];
  // Pagination properties
  page = 0;
  pageSize = 10;
  size: any = 10;
  totalRecords: number = 0;
  currentPage: number = 0;

  // Component state
  hideCompany: boolean = false;
  dateFormat: string = 'dd/MM/yyyy';
  date: any = ''
  search: string = '';
  angularDateFormat: string = '';
  isFirstLoad = true;

  approverPage: boolean = false;

  constructor(
    private readonly modalService: NgbModal,
    private readonly attendanceRegularizationService: AttendanceRegularizationService,
    private readonly employeeService: EmployeeListService,
    private readonly router: Router,
    private readonly commonService: CommonService,
    private readonly companyService: CompanyService,
    private readonly auth: AuthService,
    private readonly menuService: MenuService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.menuId = this.auth.selectedMenuID ?? 0;
    // const menuName = this.route.snapshot.data['breadcrumb'];
    // if (menuName) {
    //   this.getMenuIdByName(menuName);
    // }
    this.setupComponent();
    const currentUrl = this.router.url;
    const hasApprover = currentUrl.includes('approve-attendance-regularization');
    this.approverPage = hasApprover;
    if (hasApprover) {
      this.getRegularizationApproveList();
    } else {
      this.getRegularizationList();
    }
  }

  private setupComponent(): void {
    const userData: any = this.commonService.getLocalStorageData();
    if (userData) {
      if (!userData.client) {
        this.hideCompany = true;
        this.getDateFormat(userData.companyID);
      }
    }
  }

  private getDateFormat(companyId: number): void {
    this.companyService.getParametersById(companyId).subscribe({
      next: (resp) => {
        if (resp?.data?.date_format) {
          this.dateFormat = resp?.data?.date_format.replace('mm', 'MM');
          this.date = resp?.data?.date_format;
          this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(this.date);
        }
      },
    });
  }

  // getMenuIdByName(menuName: string): void {
  //   this.menuService.getAllMenus().subscribe({
  //     next: (res: any) => {
  //       if (res?.data && Array.isArray(res.data)) {
  //         const menu = res.data.find(
  //           (m: any) => m.name?.trim().toLowerCase() === menuName.toLowerCase(),
  //         );

  //         if (menu) {
  //           this.menuId = menu.id;
  //           // console.log(`📦 Menu ID found for "${menuName}":`, this.menuId);
  //         } else {
  //           console.warn(`⚠️ No matching menu found for "${menuName}"`);
  //           this.menuId = 0;
  //         }
  //       } else {
  //         console.error('❌ Invalid response from getAllMenus()');
  //       }
  //     },
  //     error: (err) => {
  //       console.error('❌ Failed to load menu list', err);
  //     },
  //   });
  // }
  private readonly statusDisplayToDb: Record<string, string> = {
    'pending': 'Requested',
    'approved': 'Approved',
    'rejected': 'Rejected',
    'cancelled': 'Cancelled',
  };

  handleFilterChange(payload: any) {
    this.currentPage = payload?.page ?? 0;
    this.page = this.currentPage + 1;
    if (payload?.orderby) this.currentSortField = payload.orderby;
    if (payload?.order) this.currentSortOrder = payload.order;
    if (this.approverPage) {
      this.getRegularizationApproveList(payload);
    } else {
      this.getRegularizationList(payload);
    }
  }
  onViewChange(type: 'grid' | 'list') {
    this.viewType = type;
  }
  getRegularizationList(payload?: any): void {
    const orderby = payload?.orderby || this.currentSortField || 'createdAt';
    const order = payload?.order || this.currentSortOrder || 'desc';
    const filters = payload?.filters; // may be undefined

    this.loading = true;
    const params = this.paramData(this.currentPage, this.size, this.search, filters);

    params['orderby'] = orderby;
    params['order'] = order;

    // Remap display labels back to backend DB values for status filters
    Object.keys(params).forEach(key => {
      if (key.startsWith('filters[status]') && key.endsWith('[value]')) {
        const mapped = this.statusDisplayToDb[String(params[key]).toLowerCase()];
        if (mapped) { params[key] = mapped; }
      }
    });

    this.attendanceRegularizationService.getRegularizationListWithPagi(params).subscribe({
      next: (response: any) => {
        if (response) {
          this.leaveList = response?.data?.rows || [];
          this.totalRecords = response?.data?.totalItems;
          this.currentPage = response?.data?.currentPage;
        }
      }
    });
  }
  currentSortOrder: 'asc' | 'desc' = 'desc';
  currentSortField: any = 'createdAt';
  loading: boolean = true;
  getRegularizationApproveList(payload?: any): void {
    const orderby = payload?.orderby || this.currentSortField || 'createdAt';
    const order = payload?.order || this.currentSortOrder || 'desc';
    const filters = payload?.filters; // may be undefined

    this.loading = true;
    const params = this.paramData(this.currentPage.toString(), this.size.toString(), this.search, filters);

    params['orderby'] = orderby;
    params['order'] = order;

    // Remap display labels back to backend DB values for status filters
    Object.keys(params).forEach(key => {
      if (key.startsWith('filters[status]') && key.endsWith('[value]')) {
        const mapped = this.statusDisplayToDb[String(params[key]).toLowerCase()];
        if (mapped) { params[key] = mapped; }
      }
    });

    this.attendanceRegularizationService.getRegularizationApproveListWithPagi(params).subscribe({
      next: (response: any) => {
        if (response) {
          this.leaveList = response?.data?.data || [];
          this.totalRecords = response?.data.totalItems;
          this.currentPage = response?.data.currentPage;
        }
      }
    });
  }
  paramData(page: any, size: any, search: any, filters: any) {
    let params = { page: this.currentPage, size: this.pageSize, search: this.search };
    if (page) params['page'] = page;
    if (size) params['size'] = size;
    if (search) params['search'] = search;
    const filterParams = this.buildFilterPayload(filters);
    return { ...params, ...filterParams };
  }
  buildFilterPayload(payloadData: any): any {
    const result: any = {};

    for (const key in payloadData) {
      if (payloadData.hasOwnProperty(key)) {
        const field = payloadData[key];

        if (Array.isArray(field) && field.length > 0) {
          field.forEach((item: any, index: number) => {
            let filterKey = key;
            let value: any;

            if (filterKey.startsWith('createdBy.') || filterKey.startsWith('updatedBy.')) {
              filterKey = filterKey.split('.')[0];
            }

            if (typeof item === 'object' && item !== null && 'value' in item) {
              value = item.value;

              if (
                (filterKey === 'createdBy' || filterKey === 'updatedBy') &&
                typeof value === 'object' &&
                value !== null
              ) {
                value = value.id ?? '';
              }

              if (value instanceof Date) {
                value = value.toISOString();
              }

              result[`filters[${filterKey}][${index}][value]`] = value;
              result[`filters[${filterKey}][${index}][matchMode]`] =
                item.matchMode || 'contains';
            } else {
              // Keep original behavior for all others
              result[`filters[${filterKey}][${index}][value]`] = item instanceof Date ? item.toISOString() : item;
              result[`filters[${filterKey}][${index}][matchMode]`] = 'contains';
            }
          });
        }
      }
    }

    return result;
  }
  searchTable(event: any): void {
    this.search = event.target.value;
    this.currentPage = 0;
    this.page = 0;
    if (this.approverPage) {
      this.getRegularizationApproveList();
    } else {
      this.getRegularizationList();
    }
  }

  handlePageChange(event: number): void {
    if (this.isFirstLoad) {
      this.isFirstLoad = false;
      return;
    }
    this.currentPage = event && event > 0 ? event - 1 : 0;
    // API call handled via handleFilterChange triggered by custom-table ngOnChanges
  }

  getAllForExport(): Promise<any[]> {
    const exportSize = this.totalRecords > 0 ? this.totalRecords : 100000;
    const params: any = { page: 0, size: exportSize, search: '' };
    return new Promise((resolve, reject) => {
      const api$ = this.approverPage
        ? this.attendanceRegularizationService.getRegularizationApproveListWithPagi(params)
        : this.attendanceRegularizationService.getRegularizationListWithPagi(params);
      api$.subscribe({
        next: (response: any) => {
          const rows = this.approverPage
            ? (response?.data?.data ?? [])
            : (response?.data?.rows ?? []);
          const flatRows = rows.map((item: any) => ({
            ...item,
            company: item?.company?.company_name ?? '',
            employee: `${item?.employee?.firstname ?? ''} ${item?.employee?.lastname ?? ''} (${item?.employee?.employeecode ?? ''})`.trim(),
            created_by: item?.createdBy?.name ?? '',
            updated_by: item?.updatedBy?.name ?? '',
          }));
          resolve(flatRows);
        },
        error: (err: any) => reject(err),
      });
    });
  }

  checkPermission(type: string) {
    return this.auth.checkPermission(type);
  }

  navigateTo(leaveId: string) {
    if (this.approverPage) {
      this.router.navigate(['/app/attendance/approve-attendance-regularization/', leaveId]);
    } else {
      this.router.navigate(['/app/attendance/apply-attendance-regularization/', leaveId]);
    }
  }

  // -------view approvers-----

  viewData: any = ''
  viewApprovers(content: any, data: any) {
    this.approverList = [];
    this.viewData = data;
    let ids: any[] = [];
    let approverArray = data.workflow_condition ? data?.workflow?.condition?.condition_approvers : data?.workflow?.approvers;
    if (approverArray?.length > 0) {
      ids = approverArray?.map((e: any) => e.assignee);
    } else if (data?.approved_by?.length > 0) {
      ids = data.approved_by.map((e: any) => e.employee_id);
    }
    if (ids.length > 0) {
      this.getEmployeeList(ids, data.approved_by ?? [], data);
    }

    this.modalService.open(content, { size: 'md' });
  }

  clearForm() {
    this.modalService.dismissAll();
  }

  approverList: any = []
  getEmployeeList(ids: any[], approved_by: any[], data: any) {
    this.employeeService.getEmpLoginListWithoutPagination({ employee_ids: ids }).subscribe({
      next: (resp: any) => {
        // console.log('approvedBy', resp?.data);
        const created_at = data?.createdAt;
        const approverList = (resp?.data ?? []).map((emp: any) => {
          const matched = approved_by.find((e: any) => e.employee_id == emp.id);
          // console.log('matched==>', matched);
          return {
            ...emp,
            fullName: `${emp?.username}(${emp?.Employee?.firstname} ${emp?.Employee?.lastname ?? ''})`,
            approver_status: matched?.status ?? null,
            // requested_date: this.viewData?.createdAt ?? null,
            requested_date: created_at ?? null,
            approver_date: matched?.date || null
          };
        }).sort((a: any, b: any) => {
          const indexA = approved_by.findIndex((e: any) => e.employee_id === a.id);
          const indexB = approved_by.findIndex((e: any) => e.employee_id === b.id);

          return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });
        this.approverList = approverList
      },
      error: (err) => {
        console.error("Error fetching employee list:", err);
      },
    });
  }
}

